import { render, staticRenderFns } from "./Disclaimer.vue?vue&type=template&id=587dc02b&"
import script from "./Disclaimer.vue?vue&type=script&lang=ts&"
export * from "./Disclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./Disclaimer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/tmp/build_dc55b0b5/src/components/button/Button.vue').default})
